
import startCase from "lodash/startCase";
import { Component, Vue } from "vue-property-decorator";
import { uiInfoText } from "@/helpers/ui-info-text";
import { AppTileButton } from "@/components/shared/app-tile-button.vue";
import { AppMode } from "@/store/modules/scan";

@Component({
  components: {
    AppTileButton,
  },
})
export default class MedicalSubMenu extends Vue {
  created() {
    this.$store.commit("navFuncs", {
      save: undefined,
      back: () => {
        this.$router.go(-1);
      },
    });
  }

  buttonState(appMode: AppMode) {
    return this.$store.getters["scan/isAppModeAllowedToContinue"](appMode) ? "ready" : "disabled";
  }

  isScanningBeingUsed() {
    return this.$store.getters["scan/isAppModeValidWithTagsScanned"]();
  }

  uiFriendlyAppMode(appMode: AppMode) {
    return startCase(appMode);
  }

  onClickDisabled(appModeDesired: AppMode) {
    let appModeCurrent = this.$store.state.scan.appMode;
    let message: string;
    if (appModeCurrent === "count-without-save") {
      message = this.uiFriendlyAppMode(appModeDesired) + " disabled. You must first clear the tags in " + this.uiFriendlyAppMode("count-without-save");
    } else {
      message = this.uiFriendlyAppMode(appModeDesired) + " disabled. You must first clear or save the tags in " + this.uiFriendlyAppMode(appModeCurrent);
    }
    this.$store.commit("popup/displayOk", message);
  }

  onClickInfo(title: string) {
    const info = uiInfoText[title as keyof typeof uiInfoText];
    this.$store.commit("popup/displayOk", {
      title,
      bullets: info ? info.bullets : ["No info available"],
    });
  }
}
